export class FlowRegistry {
    constructor() {
        this.flows = {};
    }
    register(flow) { this.flows[flow.id] = flow; }
    get(flowId) { return this.flows[flowId]; }
    has(flowId) { return Object.prototype.hasOwnProperty.call(this.flows, flowId); }
    listFlows() { return Object.values(this.flows); }

    rebuildGroups(flowId, itemsStates, globals, loops) {
        const flow = this.flows[flowId];
        if (!flow) return;
        flow.items.forEach((item) => {
            if (item._buildGroupFunction) {
                item.group = item._buildGroupFunction(itemsStates, globals, loops);
            }
        });
    }

    restoreVariables(flowId, loopName, globals) {
        const flow = this.flows[flowId];
        if (!flow || !flow.loopsDefinitions) return;
        const components = loopName.split('#');
        for (const component of components) {
            const indexSep = component.indexOf('$');
            const shortName = indexSep === -1 ? component : component.substring(0, indexSep);
            const def = flow.loopsDefinitions[shortName];
            if (def && typeof def.restoreVariables === 'function') {
                def.restoreVariables(globals);
            }
        }
    }
}

export function createDefaultRegistry() {
    return new FlowRegistry();
}
